// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  max-width: 100%;
}

:host([size=full]) {
  width: 100%;
  height: inherit;
}

:host([size=sm]) .ids-image,
.ids-image.sm {
  width: 60px;
  height: 60px;
}

:host([size=md]) .ids-image,
.ids-image.md {
  width: 154px;
  height: 120px;
}

:host([size=lg]) .ids-image,
.ids-image.lg {
  width: 300px;
  height: 350px;
}

:host([size=full]) .ids-image,
.ids-image.full {
  width: 100%;
  height: 100%;
}

:host(:focus-visible) {
  outline: none;
}

:host(:focus) .ids-image,
:host(:focus-visible) .ids-image {
  border-color: var(--ids-image-color-border-focus);
  box-shadow: var(--ids-image-shadow-focus);
}

:host .placeholder,
.ids-image.placeholder {
  border-radius: var(--ids-image-placeholder-border-radius);
  border-color: var(--ids-image-color-border-default);
}
:host .placeholder ids-icon,
.ids-image.placeholder ids-icon {
  color: var(--ids-image-color-text);
}

:host([round=true]) .ids-image,
.ids-image.round {
  border-radius: var(--ids-image-initials-border-radius);
  min-width: 50px;
  max-width: 50px;
  width: 50px;
  height: 50px;
}

:host([user-status]),
.user-status-wrapper {
  position: relative;
}

:host(.disabled),
:host([disabled]) {
  opacity: var(--ids-list-view-item-opacity-disabled);
}

.ids-image {
  box-sizing: border-box;
  border: 1px solid transparent;
  max-width: 100%;
  height: auto;
}
.ids-image:not(.placeholder):not(.initials) {
  display: block;
  object-fit: cover;
}
.ids-image.placeholder {
  align-items: center;
  display: inline-flex;
  background-color: var(--ids-image-placeholder-color-background);
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
}
.ids-image.initials {
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  background-color: var(--ids-image-initials-color-background);
  color: var(--ids-color-white-100);
  text-transform: uppercase;
}
.ids-image .audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.user-status {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -1px;
  bottom: -3px;
}
.user-status.available {
  color: var(--ids-image-status-available-color-background);
}
.user-status.busy, .user-status.do-not-disturb {
  color: var(--ids-image-status-busy-color-background);
}
.user-status.away {
  color: var(--ids-image-status-away-color-background);
}
.user-status.unknown {
  fill: var(--ids-image-status-unknown-color-background);
  color: var(--ids-color-transparent);
}
.user-status.meeting {
  color: var(--ids-image-status-busy-color-background);
}
.user-status::before {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-white-100);
  content: "";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 3px;
  z-index: 1;
}
.user-status::after {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
  content: "";
  width: 16px;
  height: 16px;
  left: 1px;
  top: 1px;
}
.user-status ids-icon {
  z-index: 1;
}

.user-status-wrapper .user-status {
  position: unset;
  width: 18px;
  height: 18px;
  margin-left: 36px;
  margin-top: -18px;
}
.user-status-wrapper .user-status svg {
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-image/ids-image.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAUA;EACE,qBAAA;EACA,eAAA;AATF;;AAYA;EACE,WAAA;EACA,eAAA;AATF;;AAcE;;EAEE,WAAA;EACA,YAAA;AAXJ;;AAQE;;EAEE,YAAA;EACA,aAAA;AALJ;;AAEE;;EAEE,YAAA;EACA,aAAA;AACJ;;AAJE;;EAEE,WAAA;EACA,YAAA;AAOJ;;AAFA;EACE,aAAA;AAKF;;AAAE;;EACE,iDAAA;EACA,yCAAA;AAIJ;;AACA;;EAEE,yDAAA;EACA,mDAAA;AAEF;AAAE;;EACE,kCAAA;AAGJ;;AAEA;;EAEE,sDAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AACF;;AAGA;;EAEE,kBAAA;AAAF;;AAGA;;EAEE,mDAAA;AAAF;;AAGA;EACE,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;AAAF;AAGE;EACE,cAAA;EACA,iBAAA;AADJ;AAIE;EACE,mBAAA;EACA,oBAAA;EACA,+DAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,4DAAA;EACA,iCAAA;EACA,yBAAA;AAHJ;AAME;ECnFA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADgFF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAEF;AACE;EACE,yDAAA;AACJ;AAEE;EAEE,oDAAA;AADJ;AAIE;EACE,oDAAA;AAFJ;AAKE;EACE,sDAAA;EACA,mCAAA;AAHJ;AAME;EACE,oDAAA;AAJJ;AAQE;EACE,kBAAA;EACA,6CAAA;EACA,4CAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AANJ;AASE;EACE,kBAAA;EACA,6CAAA;EACA,qDAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAPJ;AAUE;EACE,UAAA;AARJ;;AAYA;EAME,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAdF;AAKE;EACE,6CAAA;EACA,qDAAA;AAHJ","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use 'sass:list';\n\n$image-sizes: (\n  'sm': (60px, 60px),\n  'md': (154px, 120px),\n  'lg': (300px, 350px),\n  'full': (100%, 100%),\n);\n\n:host {\n  display: inline-block;\n  max-width: 100%;\n}\n\n:host([size='full']) {\n  width: 100%;\n  height: inherit;\n}\n\n// set size\n@each $key, $value in $image-sizes {\n  :host([size='#{$key}']) .ids-image,\n  .ids-image.#{$key} {\n    width: list.nth($value, 1);\n    height: list.nth($value, 2);\n  }\n}\n\n// focus state\n:host(:focus-visible) {\n  outline: none;\n}\n\n:host(:focus),\n:host(:focus-visible) {\n  .ids-image {\n    border-color: var(--ids-image-color-border-focus);\n    box-shadow: var(--ids-image-shadow-focus);\n  }\n}\n\n// normal\n:host .placeholder,\n.ids-image.placeholder {\n  border-radius: var(--ids-image-placeholder-border-radius);\n  border-color: var(--ids-image-color-border-default);\n\n  ids-icon {\n    color: var(--ids-image-color-text);\n  }\n}\n\n// round attribute\n:host([round='true']) .ids-image,\n.ids-image.round {\n  border-radius: var(--ids-image-initials-border-radius);\n  min-width: 50px;\n  max-width: 50px;\n  width: 50px;\n  height: 50px;\n}\n\n// user-status attribute\n:host([user-status]),\n.user-status-wrapper {\n  position: relative;\n}\n\n:host(.disabled),\n:host([disabled]) {\n  opacity: var(--ids-list-view-item-opacity-disabled);\n}\n\n.ids-image {\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  max-width: 100%;\n  height: auto;\n\n  // img only related\n  &:not(.placeholder):not(.initials) {\n    display: block;\n    object-fit: cover;\n  }\n\n  &.placeholder {\n    align-items: center;\n    display: inline-flex;\n    background-color: var(--ids-image-placeholder-color-background);\n    justify-content: center;\n    min-width: 50px;\n    min-height: 50px;\n  }\n\n  &.initials {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-width: 50px;\n    min-height: 50px;\n    background-color: var(--ids-image-initials-color-background);\n    color: var(--ids-color-white-100);\n    text-transform: uppercase;\n  }\n\n  .audible {\n    @include mixins.audible();\n  }\n}\n\n.user-status {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  right: -1px;\n  bottom: -3px;\n\n  // icon colors\n  &.available {\n    color: var(--ids-image-status-available-color-background);\n  }\n\n  &.busy,\n  &.do-not-disturb {\n    color: var(--ids-image-status-busy-color-background);\n  }\n\n  &.away {\n    color: var(--ids-image-status-away-color-background);\n  }\n\n  &.unknown {\n    fill: var(--ids-image-status-unknown-color-background);\n    color: var(--ids-color-transparent);\n  }\n\n  &.meeting {\n    color: var(--ids-image-status-busy-color-background);\n  }\n\n  // Draw a border and ring around the background color\n  &::before {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-white-100);\n    content: '';\n    width: 12px;\n    height: 12px;\n    left: 3px;\n    top: 3px;\n    z-index: 1;\n  }\n\n  &::after {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-background-default);\n    content: '';\n    width: 16px;\n    height: 16px;\n    left: 1px;\n    top: 1px;\n  }\n\n  ids-icon {\n    z-index: 1;\n  }\n}\n\n.user-status-wrapper .user-status {\n  svg {\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-background-default);\n  }\n\n  position: unset;\n  width: 18px;\n  height: 18px;\n  margin-left: 36px;\n  margin-top: -18px;\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
